import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const assignGamePartners = async (data: PropertyType): Promise<PropertyType> => {
	try {
		await api.post('/games/partners', mapEntityToApi(data), setConfig(data));
		return { message: UPDATE_GAME_MESSAGE };
	} catch (error: any) {
		const apiError = error.response?.data?.errors?.error?.[0] || '';
		throw new Error(apiError);
	}
};
